import Reducer from './../util/reducer'

const reducer = new Reducer()

reducer.register('GET_STAGES/SUCCESS', (info) => {
  const stages = info.result
  const result = { list: {} }
  stages.forEach(stage => {
    result.list[stage.stageId] = stage
  })
  return result
})

reducer.register('GET_STAGE/SUCCESS', (info) => {
  const stage = info.result
  const result = { list: {} }
  result.list[stage.stageId] = stage
  return result
})

export default reducer.build()